import React from 'react';
import type { EventListItem, ConnectionState, AWSRegion } from '../types';
import { EventList } from './EventList';
import { ConnectionStatusIndicator } from './ConnectionStatusIndicator';
import './RegionColumn.css';

export interface RegionColumnProps {
  region: AWSRegion;
  events: EventListItem[];
  connectionStatus: ConnectionState;
  onReconnect?: () => void;
}

/**
 * RegionColumn component displays EC2 events for a specific AWS region
 * in a fixed-width column with independent scrolling
 * Requirements: 4.1, 4.2, 4.3, 4.5, 4.6
 */
export const RegionColumn: React.FC<RegionColumnProps> = ({
  region,
  events,
  connectionStatus,
  onReconnect,
}) => {
  return (
    <div className="region-column">
      <div className="region-header">
        <h2 className="region-name">{region}</h2>
        <ConnectionStatusIndicator
          connectionState={connectionStatus}
          onReconnect={onReconnect}
        />
      </div>
      <div className="region-content">
        <EventList events={events} />
      </div>
    </div>
  );
};
